<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Usuarios</p>
    <h2 class="">Usuarios</h2>
  </div>
</div>
<!-- CONTENT -->
<div class="content-block">
  <div class="dx-card responsive-paddings">
    <h2 class="mb-0">Usuarios administrativos</h2>
    <dx-data-grid #grid [dataSource]="usersListAdmin" [repaintChangesOnly]="true" keyExpr="id"
      [allowColumnReordering]="true" (onRowUpdating)="updateUser($event)" (onEditingStart)="onEditingStart($event)"
      [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }" showBorders="true" (onRowRemoving)="deleteData($event.key)" class="usersGrid">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <!-- <dxo-filter-row visible="true" applyFilter="currentFilter"></dxo-filter-row> -->
      <dxo-header-filter visible="true"></dxo-header-filter>
      <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
      <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="true">
        <dxo-popup title="Nuevo usuario" [showTitle]="true" [width]="750" [height]="780"></dxo-popup>
        <dxo-form>
          <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
            <dxi-item dataField="name" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="middleName" dataType="string" [isRequired]="false">
              <dxo-label text="Segundo nombre"></dxo-label>
            </dxi-item>
            <dxi-item dataField="lastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="secondLastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="phone" dataType="string" [editorOptions]="{ mask: '(000) 000-00-00'}">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="email" dataType="string" [disabled]="emailDisabled">
              <dxi-validation-rule type="email" message="Email es invälido">
              </dxi-validation-rule>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="city" dataType="string" [isRequired]="true">
              <dxo-label text="Ciudad"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="birthDate" dataType="number" [isRequired]="true" [template]="'birthDateSelect'" [disabled]="emailDisabled">
              <dxo-label text="Fecha de nacimiento"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="gender" dataType="string" [isRequired]="true">
              <dxo-label text="Género"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="companyId" dataType="string" [isRequired]="true">
              <dxo-label text="Empresa"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="userNumber" dataType="string" [isRequired]="false"></dxi-item>
            <dxi-item dataField="ine" dataType="string" [isRequired]="false" cssClass="uper-case"></dxi-item>
            <dxi-item dataField="passport" dataType="string" [isRequired]="false" cssClass=""></dxi-item>
            <dxi-item dataField="rfc" dataType="string" [isRequired]="true" cssClass="uper-case">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>
          <div *dxTemplate="let data of 'birthDateSelect'">
            <dx-date-box displayFormat="shortdate" type="date" [value]="tempBirthDate">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </div>
        </dxo-form>
      </dxo-editing>
      <dxi-column dataField="name" caption="Nombre" sortOrder="asc"></dxi-column>
      <dxi-column dataField="lastName" caption="Primer apellido" dataType="string"></dxi-column>
      <dxi-column dataField="secondLastName" caption="Segundo apellido" dataType="string"></dxi-column>
      <dxi-column dataField="phone" caption="Teléfono" dataType="string"></dxi-column>
      <dxi-column dataField="email" caption="e-mail" dataType="string"></dxi-column>
      <dxi-column dataField="userNumber" caption="Número de empleado" dataType="string" cssClass="uper-case"
        [visible]="false">
      </dxi-column>
      <dxi-column dataField="ine" caption="INE" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="passport" dataType="string" caption="Pasaporte" [visible]="false"></dxi-column>
      <dxi-column dataField="middleName" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="city" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="rfc" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="gender" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="genderOptions" displayExpr="name" valueExpr="val">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="birthDate" dataType="number" [visible]="false"></dxi-column>
      <div *dxTemplate="let user of 'detail'">
        <div class="flex flex-nowrap details-templateW  datagrid-detailsW flex-space-around">
          <div class="">
            <h2>Detalle de usuario</h2>
            <ul>
              <li>Empresa: {{user.data.companyName}}</li>
              <li>Nombre: {{user.data.name}} {{user.data.middleName}} {{user.data.lastName}}
                {{user.data.secondLastName}}</li>
              <li>Email: {{user.data.email}}</li>
              <li>Tel: {{user.data.phone}}</li>
              <li># empleado: {{user.data.userNumber}}</li>
              <li><span *ngIf="user.data.active"><i class="fad fa-check-circle brand-color"></i></span><span
                  *ngIf="!user.data.active"><i class="fad fa-do-not-enter dangerColor"></i></span> Activo</li>
            </ul>
          </div>
          <div class="">
            <h2>Detalle de usuario</h2>
            <ul>
              <li>RFC: {{user.data.rfc}}</li>
              <li>IFE: {{user.data.ine}}</li>
              <li>Pasaporte: {{user.data.passport}}</li>
              <li>ID: {{user.data.id}}</li>
            </ul>
          </div>

        </div>
      </div>
      <dxi-column dataField="companyName" caption="Empresa" dataType="string"></dxi-column>
      <dxi-column dataField="companyId" caption="Empresa" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="companiesList" displayExpr="companyName" valueExpr="id">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  </div>
  <div class="dx-card responsive-paddings mt-5">
    <h2 class="mb-0">Usuarios de programa</h2>
    <dx-data-grid #grid [dataSource]="usersListIhunter" [repaintChangesOnly]="true" keyExpr="id"
      [allowColumnReordering]="true" (onRowUpdating)="updateUser($event)" (onEditingStart)="onEditingStart($event)"
      [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }" showBorders="true" (onRowRemoving)="deleteData($event.key)" class="usersGrid">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <!-- <dxo-filter-row visible="true" applyFilter="currentFilter"></dxo-filter-row> -->
      <dxo-header-filter visible="true"></dxo-header-filter>
      <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
      <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="true">
        <dxo-popup title="Nuevo usuario" [showTitle]="true" [width]="750" [height]="780"></dxo-popup>
        <dxo-form>
          <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
            <dxi-item dataField="name" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="middleName" dataType="string" [isRequired]="false">
              <dxo-label text="Segundo nombre"></dxo-label>
            </dxi-item>
            <dxi-item dataField="lastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="secondLastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="phone" dataType="string" [editorOptions]="{ mask: '(000) 000-00-00'}">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="email" dataType="string" [disabled]="emailDisabled">
              <dxi-validation-rule type="email" message="Email es invälido">
              </dxi-validation-rule>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="city" dataType="string" [isRequired]="true">
              <dxo-label text="Ciudad"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="birthDate" dataType="number" [isRequired]="true" [template]="'birthDateSelect'" [disabled]="emailDisabled">
              <dxo-label text="Fecha de nacimiento"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="gender" dataType="string" [isRequired]="true">
              <dxo-label text="Género"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="companyId" dataType="string" [isRequired]="true">
              <dxo-label text="Empresa"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="userNumber" dataType="string" [isRequired]="false"></dxi-item>
            <dxi-item dataField="ine" dataType="string" [isRequired]="false" cssClass="uper-case"></dxi-item>
            <dxi-item dataField="passport" dataType="string" [isRequired]="false" cssClass=""></dxi-item>
            <dxi-item dataField="rfc" dataType="string" [isRequired]="true" cssClass="uper-case">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>
          <div *dxTemplate="let data of 'birthDateSelect'">
            <dx-date-box displayFormat="shortdate" type="date" [value]="tempBirthDate">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </div>
        </dxo-form>
      </dxo-editing>
      <dxi-column dataField="id" caption="id" [visible]="false"></dxi-column>
      <dxi-column dataField="name" caption="Nombre" sortOrder="asc"></dxi-column>
      <dxi-column dataField="lastName" caption="Primer apellido" dataType="string"></dxi-column>
      <dxi-column dataField="secondLastName" caption="Segundo apellido" dataType="string"></dxi-column>
      <dxi-column dataField="phone" caption="Teléfono" dataType="string"></dxi-column>
      <dxi-column dataField="email" caption="e-mail" dataType="string"></dxi-column>
      <dxi-column dataField="userNumber" caption="Número de empleado" dataType="string" cssClass="uper-case"
        [visible]="false">
      </dxi-column>
      <dxi-column dataField="ine" caption="INE" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="passport" dataType="string" caption="Pasaporte" [visible]="false"></dxi-column>
      <dxi-column dataField="middleName" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="city" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="rfc" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="gender" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="genderOptions" displayExpr="name" valueExpr="val">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="birthDate" dataType="number" [visible]="false"></dxi-column>
      <div *dxTemplate="let user of 'detail'">
        <div class="flex flex-nowrap flex-start datagrid-detailsW">
          <div class="mr-5 ml-5">
            <h2>Detalle de usuario</h2>
            <ul>
              <li>Empresa: {{user.data.companyName}}</li>
              <li>Nombre: {{user.data.name}} {{user.data.middleName}} {{user.data.lastName}}
                {{user.data.secondLastName}}</li>
              <li>Email: {{user.data.email}}</li>
              <li>Tel: {{user.data.phone}}</li>
              <li># empleado: {{user.data.userNumber}}</li>
              <li>ID ihunter: {{user.data.id}}</li>
              <li><span *ngIf="user.data.active"><i class="fad fa-check-circle brand-color"></i></span><span
                  *ngIf="!user.data.active"><i class="fad fa-do-not-enter dangerColor"></i></span> Activo</li>
            </ul>
          </div>
          <div class="mr-5 ml-5">
            <h2>Detalle de tarjeta</h2>
            <ul *ngFor="let program of user.data.program">
              <li>Programa: {{program.programName}}</li>
              <li>Convenio: {{program.agreementNNumber}}</li>
              <ng-container *ngIf="!program.card">
                <li>Tarjeta: Tarjeta no Vinculada</li>
              </ng-container>
              <ng-container *ngIf="program.card">
                <li >Tarjeta: **** **** **** {{program.card.number}}</li>
                <li>
                  Tarjeta activada
                  <span *ngIf="!program.card"><i class="fad fa-do-not-enter dangerColor"></i></span>
                  <span *ngIf="program.card.status"><i class="fad fa-check-circle brand-color"></i></span>
                </li>
                <li *ngIf="program.card">Fecha de activación: {{program.card.dateCardAssigned}}</li>
                <li *ngIf="program.card">Status de NIP: {{program.card.statusNIP}}</li>
              </ng-container>
            </ul>
          </div>

          <div>
            <h2>Acciones</h2>
            <dx-button text="Detalle Usuario" icon="far fa-id-card" type="default" [routerLink]="['detail',user.data.id]"></dx-button>
          </div>
        </div>
      </div>
      <dxi-column dataField="companyName" caption="Empresa" dataType="string"></dxi-column>
      <dxi-column dataField="companyId" caption="Empresa" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="companiesList" displayExpr="companyName" valueExpr="id">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>